// eslint-disable-next-line import/prefer-default-export
export const REVIEW_SECTIONS = [
  { title: "My Reviews", sectionType: "Personal" },
  { title: "Peer Reviews", sectionType: "Peer" },
  { title: "Manager Reviews", sectionType: "Manager" },
];
